import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import data from "@/constants/seoPages.json";

export default function SeoServicePage({ slug: slugProp }) {
  const params = useParams();
  const slug = slugProp || params.slug;
  const page = data.pages.find((p) => p.slug === slug);
  if (!page) return <Navigate to="/services" replace />;
  const others = data.pages.filter((p) => p.slug !== slug);

  return (
    <>
      <Seo title={page.title} description={page.description} path={`/${page.slug}`} />
      <PageHeader eyebrow={page.eyebrow} title={page.h1} sub={page.intro} pageTitle={page.title} />

      <article className="py-16 lg:py-20">
        <div className="mx-auto max-w-3xl px-6 lg:px-0">
          {page.sections.map((s) => (
            <Reveal key={s.h2}>
              <section className="mb-12">
                <h2 className="font-display text-2xl font-extrabold tracking-tight text-ink">{s.h2}</h2>
                {s.paragraphs.map((t, i) => (
                  <p key={i} className="mt-4 text-base leading-relaxed text-neutral-600">{t}</p>
                ))}
                {s.bullets && (
                  <ul className="mt-4 list-disc space-y-2 pl-5 text-base leading-relaxed text-neutral-600">
                    {s.bullets.map((b) => <li key={b}>{b}</li>)}
                  </ul>
                )}
              </section>
            </Reveal>
          ))}

          <section className="mb-12">
            <h2 className="font-display text-2xl font-extrabold tracking-tight text-ink">Questions fréquentes</h2>
            <Accordion type="single" collapsible className="mt-4">
              {page.faq.map((f, i) => (
                <AccordionItem key={i} value={`q-${i}`} className="border-black/10">
                  <AccordionTrigger className="py-4 text-left font-display text-base font-bold text-ink hover:text-accent hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm leading-relaxed text-neutral-600">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </section>

          <div className="rounded-[20px] border border-black/10 bg-mist p-8">
            <h2 className="font-display text-xl font-bold text-ink">Un projet en tête ?</h2>
            <p className="mt-2 text-sm text-neutral-600">Devis gratuit, réponse sous 48 h ouvrées.</p>
            <Link
              to="/devis"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 font-mono text-[11px] uppercase tracking-[0.18em] text-white"
            >
              Demander un devis <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </div>

          <nav aria-label="Autres services" className="mt-10 text-sm text-neutral-600">
            À voir aussi :{" "}
            {others.map((o, i) => (
              <span key={o.slug}>
                {i > 0 && " · "}
                <Link className="text-accent underline" to={`/${o.slug}`}>{o.eyebrow}</Link>
              </span>
            ))}
          </nav>
        </div>
      </article>
    </>
  );
}
